<template>
  <v-card class="your-claims-container" data-testid="pax-your-claims">
    <div class="d-flex justify-space-between align-center">
      <Typography variant="h-2">Your Claims</Typography>
      <Button data-testid="submit-claim-button" iconLeft="mdi-plus" @click="openSubmitClaimModal"
        >Submit Claim</Button
      >
    </div>
    <v-tabs class="status-tabs" color="brandPrimary" v-model="tab">
      <v-tab data-testid="pax-your-claims-approved-tab">Approved</v-tab>
      <v-tab data-testid="pax-your-claims-pending-tab"
        >Pending ({{ pendingClaimOptions.total }})</v-tab
      >
      <v-tab data-testid="pax-your-claims-denied-tab">Denied</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <ParticipantClaimsTabItem
        :claims="approvedClaims"
        :claimOptions="approvedClaimOptions"
        :isLoading="isLoading"
        :noClaimsMessage="noClaimsMessage"
        dataTestId="pax-your-claims-approved-tab-item"
        @update:claimOptions="$emit('update:approvedClaimOptions', $event)"
      />
      <ParticipantClaimsTabItem
        dataTestId="pax-your-claims-pending-tab-item"
        :claims="pendingClaims"
        :claimOptions="pendingClaimOptions"
        :isLoading="isLoading"
        :noClaimsMessage="noClaimsMessage"
        @update:claimOptions="$emit('update:pendingClaimOptions', $event)"
      />
      <ParticipantClaimsTabItem
        dataTestId="pax-your-claims-denied-tab-item"
        :claims="deniedClaims"
        :claimOptions="deniedClaimOptions"
        :isLoading="isLoading"
        :noClaimsMessage="noClaimsMessage"
        @update:claimOptions="$emit('update:deniedClaimOptions', $event)"
      />
    </v-tabs-items>
    <FormSelectionModal v-model="showFormSelectionModal" @select="selectForm" />
  </v-card>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";
import ParticipantClaimsTabItem from "./ParticipantClaimsTabItem.vue";
import FormSelectionModal from "./FormSelectionModal.vue";

export default {
  name: "ParticipantClaims",
  components: {
    Typography,
    Button,
    ParticipantClaimsTabItem,
    FormSelectionModal,
  },
  props: {
    approvedClaims: {},
    pendingClaims: {},
    deniedClaims: {},
    approvedClaimOptions: {
      type: Object,
      default: () => ({
        total: 0,
        page: 1,
        itemsPerPage: 10,
        sortOrder: "desc",
      }),
    },
    pendingClaimOptions: {
      type: Object,
      default: () => ({
        total: 0,
        page: 1,
        itemsPerPage: 10,
        sortOrder: "desc",
      }),
    },
    deniedClaimOptions: {
      type: Object,
      default: () => ({
        total: 0,
        page: 1,
        itemsPerPage: 10,
        sortOrder: "desc",
      }),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tab: 0,
      noClaimsMessage: "There aren't any claims here right now.",
      showFormSelectionModal: false,
    };
  },
  methods: {
    openSubmitClaimModal() {
      this.showFormSelectionModal = true;
    },
    selectForm(form) {
      this.showFormSelectionModal = false;
      this.$router
        .push({ path: `/form/${form.formUuid}`, query: { from: "claims" } })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.your-claims-container {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.status-tabs {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
